
import { defineComponent, ref } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "GrandMenu",
  setup() {
    const { router } = usePlugin();
    const documentId = ref("");
    const onGoToDocument = () => {
      router.push({
        name: "editTrainingDocument",
        params: { docNo: documentId.value },
      });
    };

    return {
      onGoToDocument,
      documentId,
    };
  },
});
